import Service from "../../../../../../dto/Service"

export enum ActionType {
    SERVICE_LOADING = 'SERVICE_LOADING',
    SERVICE_DATA = 'SERVICE_DATA',
    SERVICE_ERROR = 'SERVICE_ERROR',
    SERVICE_SELECTED = 'SERVICE_SELECTED',
}

export interface ActionServices {
    type: ActionType.SERVICE_DATA,
    list: Service[]
}

export interface ActionServicesFetchError {
    type: ActionType.SERVICE_ERROR,
    message: String
}

export interface ActionSelected {
    type: ActionType.SERVICE_SELECTED,
    item: Service
}
type Action = ActionServices | ActionServicesFetchError | ActionSelected

export default Action